<template>
  <div class="book-view-toggle">
    <div
      :class="{
        'book-view-button': true,
        active: $store.state.ui.mode !== 'book-view'
      }"
      @click="$store.dispatch('setMode', 'normal')"
    >
      map
    </div>
    <div
      :class="{
        'book-view-button': true,
        active: $store.state.ui.mode === 'book-view'
      }"
      @click="$store.dispatch('setMode', 'book-view')"
    >
      focus
    </div>
  </div>
</template>

<script>
export default {
  name: "BookViewToggle",
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "@/constants/_variables.scss";

.book-view-toggle {
  display: flex;
  flex-direction: row;
  text-transform: uppercase;
}

.book-view-button {
  background: white;
  border: 1px solid black;
  color: $brown-grey;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  min-width: 75px;
  padding: 0.25rem;

  &.active,
  &:hover {
    background: black;
    color: white;
  }
}
</style>
